module.exports = __webpack_public_path__ + "static/media/it-medium.13cad403.svg";